import {types} from 'mobx-state-tree';
import MapInstance from 'src/components/map/MapInstance.js';

const MapModel = types
  .model('Map', {
    selectedMap: types.enumeration(['osm', 'street', 'satellite']),
    center: types.frozen([0, 0]),
    zoom: types.optional(types.integer, 4),
    customTiles: types.frozen({}),
    trace: types.optional(types.boolean, false),
    follow: types.optional(types.boolean, false),
    labels: types.optional(types.boolean, false),
    geofences: types.frozen([]),
  })
  .actions((self) => ({
    setCenter: ({longitude, latitude}) => {
      if (typeof longitude === 'number' &&
        typeof latitude === 'number' &&
        longitude !== 0 &&
        latitude !== 0
      ) {
        self.center = [longitude, latitude];
      }
    },
    setZoom: (value) => {
      self.zoom = value;
    },
    setCustomTiles: (value) => {
      self.customTiles = value;
    },
  }))
  .actions((self) => ({
    setMap: (value) => (self.selectedMap = value),
    setInfoBase: ({zoom, center, customTiles}) => {
      if (zoom) {
        self.setZoom(zoom);
      }
      if (center) {
        self.setCenter(center);
      }
      if (customTiles) {
        self.setCustomTiles(customTiles);
      }
    },
    setFollow: (value) => (self.follow = value),
    showLabels: (value) => (self.labels = value),
    addGeofence: (geofence) => (self.geofences = [...self.geofences, geofence]),
  }))
  .views((self) => ({
    get olCenter() {
      return MapInstance.createCoordinate(self.center);
    },

    get olCustomTiles() {
      return Object.entries(self.customTiles).reduce((accu, [tileName, tileUrl]) => {
        if (tileUrl) {
          accu.push(MapInstance.createTileXYZ(tileUrl, tileName));
        }
        return accu;
      }, []);
    },
  }));

export default MapModel;
